export namespace LocationErrorConstants {
  export const IMPRECISE_LOCATION: RegExp = /is too imprecise. Try again with a more specific query/;
  export const LOOKUP_ERROR: RegExp = /Could not lookup location/;
  export const LOCATION_NOT_FOUND: RegExp = /No location found for address/;
  export const FAVORITE_LOCATION_ALREADY_EXISTS: RegExp = /Favorite location with locationId=\[.*\] and riderId=\[.*\] already exists/;
  export const FAVORITE_LOCATION_LABEL_ALREADY_EXISTS: RegExp = /Favorite location with label=\[.*\] and riderId=\[.*\] already exists/;
}
